module.exports = __webpack_public_path__ + "static/img/19.eb48425.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/19.png
// module id = w9GH
// module chunks = 0